import type { NovaEvent } from "@nova/types";
import type { MailboxInfo } from "owa-client-types";
import type { AppHostServiceEventOriginator } from "./originator";

export const EditPrivateDistributionListEventType = "editPrivateDistributionList" as const;

export type EditPrivateDistributionListData = {
    itemId: string;
    mailboxInfo: MailboxInfo;
};

export interface EditPrivateDistributionListEvent extends NovaEvent<EditPrivateDistributionListData> {
    originator: typeof AppHostServiceEventOriginator;
    type: typeof EditPrivateDistributionListEventType;
    data: () => EditPrivateDistributionListData;
}
